export const LIMIT_TO_UNLOCK = +process.env.REACT_APP_LIMIT_TO_UNLOCK_SCROLL!;
export const LIMIT_TO_CONTRIBUTE = 100;
export const SCROLL_CHIMPION_AMOUNT = +process.env.REACT_APP_SCROLL_NFT_SHARES!;

export const TIP_NOT_SEQUENCED = "For a seamless storyline experience, remember to unlock the scrolls in sequence. Let’s keep the adventure flowing smoothly!";
export const TIP_UNLOCKED = "The more bananas you contribute, the higher you'll soar on the Lore Leaderboard! Rack up those bananas and watch your rank rise.";
export const TIP_LOCKED = "100 unique contributors are needed to unlock each scroll. Hurry, join the effort and help unveil our history.";
